import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DislikeFilledSvg from "@ant-design/icons-svg/es/asn/DislikeFilled";
import AntdIcon from "../components/AntdIcon";
var DislikeFilled = function DislikeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DislikeFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DislikeFilled.displayName = 'DislikeFilled';
}
export default /*#__PURE__*/React.forwardRef(DislikeFilled);